
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Chat extends Vue {
    @Prop() accessibilityDescription!: string;
    @Prop() from?: string;
    @Prop() avatarSrc?: string;
    @Prop() date?: string;
    @Prop() headerIntro?: string;
    @Prop() dateIntro?: string;
    @Prop() showTour?: boolean;
    @Prop() messageInput?: boolean;

    @Prop({default : true}) allowScroll?: boolean;

    @Watch('showTour')
    mounted(){
      if(this.showTour)
        (this as any).$intro().start();
      this.suppressLiveLinks();
    }
    onShowTourChanged(val: boolean, oldVal: boolean) {
      if(!oldVal && val)
        (this as any).$intro().start();
    }
    suppressLiveLinks(){
      Array.from(document.querySelectorAll('.Chat a')).map((link)=>{
        link.addEventListener('click',this.suppressLink);
      });
    }
    suppressLink(e:Event){
      e.preventDefault();
    }

}
